<template>
  <!-- Üst menü ve footer uygulamanın kendi düzeninden (LayoutVertical) gelir; burada yalnızca içerik var -->
  <div
    class="legal-page legal-page--in-app"
    :dir="isRtl ? 'rtl' : 'ltr'"
  >
    <div class="legal-page__main">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegalLayout',
  computed: {
    isRtl() {
      return this.$i18n.locale === 'ar'
    },
  },
}
</script>

<style lang="scss">
.legal-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(1200px 600px at 85% -10%, rgba(234, 3, 178, 0.18), transparent 60%),
    radial-gradient(900px 500px at -10% 10%, rgba(124, 58, 237, 0.22), transparent 60%),
    #0f0826;
  color: rgba(236, 232, 255, 0.86);

  a {
    color: #f472b6;
  }
}

.legal-page--in-app {
  min-height: 0;
  display: block;
  background: transparent;

  .legal-page__main {
    padding-top: 8px;
  }
}

.legal-page__main {
  flex: 1 0 auto;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 56px;
}

.legal-card {
  position: relative;
  background: rgba(32, 22, 72, 0.72);
  border: 1px solid rgba(150, 110, 255, 0.28);
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(6, 2, 24, 0.45);
  padding: 28px 32px 32px;
}

.legal-title {
  color: #fff !important;
  font-size: 30px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0 0 10px;
}

.legal-lead {
  color: rgba(236, 232, 255, 0.78);
  font-size: 16px;
  margin: 0;
}

.legal-note {
  color: rgba(236, 232, 255, 0.55);
  font-size: 13px;
  margin: 24px 0 0;
}

.legal-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(236, 232, 255, 0.7) !important;

  &:hover {
    color: #fff !important;
  }

  [dir='rtl'] & svg {
    transform: scaleX(-1);
  }
}

@media (max-width: 575px) {
  .legal-page__main {
    padding: 22px 16px 40px;
  }

  .legal-card {
    padding: 22px 18px 24px;
    border-radius: 16px;
  }

  .legal-title {
    font-size: 24px;
  }
}
</style>
